<template>
  <div class="auth-failed">
    <div class="auth-failed__card">
      <div class="auth-failed__icon">
        <svg viewBox="0 0 24 24" width="100%" height="100%" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12 2.75l7.5 3.34v5.16c0 4.28-2.98 8.28-7.5 9.75-4.52-1.47-7.5-5.47-7.5-9.75V6.09L12 2.75z"
            fill="url(#afg)" />
          <path d="M12 8.4v4.2M12 15.4v.05" stroke="#fff" stroke-width="1.7"
            stroke-linecap="round" />
          <defs>
            <linearGradient id="afg" x1="4" y1="3" x2="20" y2="21" gradientUnits="userSpaceOnUse">
              <stop stop-color="#ff7a59" />
              <stop offset="1" stop-color="#f73727" />
            </linearGradient>
          </defs>
        </svg>
      </div>
      <div class="auth-failed__title">授权失败</div>
      <div class="auth-failed__desc">
        无法验证你的登录信息<br />
        请<span class="auth-failed__hl">重新在游戏内打开</span>本页面
      </div>
      <div class="auth-failed__tip">如多次出现此提示，请联系游戏客服</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AuthFailed",
};
</script>

<style scoped>
.auth-failed {
  min-height: 100vh;
  background: #f5f6f8;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.2rem;
}
.auth-failed__card {
  width: 100%;
  max-width: 18rem;
  background: #fff;
  border-radius: 0.9rem;
  box-shadow: 0 0.4rem 1.4rem rgba(0, 0, 0, 0.06);
  padding: 2.2rem 1.4rem 2rem;
  text-align: center;
}
.auth-failed__icon {
  width: 4.2rem;
  height: 4.2rem;
  margin: 0 auto 1.1rem;
}
.auth-failed__title {
  font-size: 1.15rem;
  font-weight: 600;
  color: #1f2329;
  margin-bottom: 0.55rem;
}
.auth-failed__desc {
  font-size: 0.82rem;
  color: #6b7280;
  line-height: 1.7;
}
.auth-failed__hl {
  color: #f73727;
  font-weight: 600;
}
.auth-failed__tip {
  margin-top: 1.3rem;
  font-size: 0.68rem;
  color: #b3b8c2;
}
</style>
